<template>
  <div>
    <el-checkbox v-model="textToSpeech" @change="updateTextToSpeechBox"
      >Generate media file from text</el-checkbox
    >
    <div v-if="textToSpeech">
      <dads-select v-model="gender" placeholder="Select voice gender">
        <el-option
          v-for="{ label, value } of genderOptions"
          :key="value"
          :label="label"
          :value="value"
        ></el-option>

        <template slot="prefix">Gender</template>
      </dads-select>

      <el-input
        v-model="textBody"
        type="textarea"
        :rows="3"
        :maxlength="1250"
        :show-word-limit="true"
        placeholder="Enter the text."
      ></el-input>

      <el-tag v-if="textBody">
        <i class="el-icon-info" style="margin-right: 4px" />
        This is the most recently saved tts text
      </el-tag>

      <div class="flex pb-10">
        <div class="box right">
          <span style="font-size: 10px;"> {{ textBody.length }}/1250</span>
        </div>
      </div>

      <el-button @click="convertTextToSpeech">Text to Speech</el-button>
      <el-tooltip v-if="blob" placement="top" content="Download">
        <el-button
          icon="el-icon-download"
          circle
          v-loading="downloading"
          @click="downloadFile"
        />
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { hostServer } from "@/feathers/feathers-client";
import DadsSelect from "@/components/select";

export default {
  name: "TextToSpeech",

  props: {
    clearFields: { required: true },
    mediaFileText: {required: true}
  },

  components: {
    DadsSelect
  },

  data() {
    return {
      gender: "",
      genderOptions: [
        { label: "Male (US)", value: "MALE_us" },
        { label: "Male (UK)", value: "MALE_uk"},
        { label: "Female (US)", value: "FEMALE_us" },
        { label: "Female (UK)", value: "FEMALE_uk"}
      ],
      textToSpeech: false,
      textBody: this.mediaFileText,
      blob: null,
      downloading: false
    };
  },

  watch: {
    clearFields(val) {
      if (val) {
        this.textToSpeech = false;
        this.blob = null;
        this.gender = "";
        this.textBody = "";
      }
    },

    mediaFileText(){
      console.log("changing!!!");
      this.textBody = this.mediaFileText;
    }
  },

  methods: {
    sanitizeText(text) {
      if (!text) return text;
      const map = {
        "‘": "'", "’": "'", "‚": "'", "‛": "'",
        "“": '"', "”": '"', "„": '"', "‟": '"',
        "′": "'", "″": '"',
        "‐": "-", "‑": "-", "‒": "-", "–": "-",
        "—": "-", "―": "-", "−": "-",
        " ": " ", " ": " ", " ": " ", " ": " ",
        "​": "", "­": "",
        "…": "...", "•": "*",
      };
      return text.replace(
        /[‘-‟′″‐-―−    ​­…•]/g,
        ch => (map[ch] !== undefined ? map[ch] : ch)
      );
    },

    async convertTextToSpeech() {
      this.textBody = this.sanitizeText(this.textBody);
      if (!this.textBody) {
        this.$notify({
          type: "error",
          title: "Text body is empty",
          message: "You must provide the text body."
        });
        return;
      }

      if (!this.gender) {
        this.$notify({
          type: "error",
          title: "Gender is not selected.",
          message: "Please select the gender."
        });
        return;
      }

      const body = {
        text: this.textBody,
        gender: this.gender.split('_')[0],
        region: this.gender.split('_')[1]
      };

      try {
        this.$emit("processingStart");
        const res = await fetch(
          `${hostServer}/mediafiles?context=textToSpeech`,
          {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
              "Content-Type": "application/json"
            }
          }
        );
        const result = await res.json();

        const bufferlen = result.audio.data.length;
        const bufferArray = new Uint8Array(bufferlen);
        for (let i = 0; i < bufferlen; i++) {
          bufferArray[i] = result.audio.data[i];
        }

        this.blob = new Blob([bufferArray.buffer], {
          type: "audio/mp3"
        });

        this.$emit("processingComplete", {blob: this.blob, text: this.textBody});
        this.$emit("processingEnd");
      } catch (err) {
        this.$emit("processingEnd");
        this.$notify({
          type: "warning",
          title: "Warning",
          message: "Text to Speech couldn't be completed."
        });
        console.log(err);
      }
    },

    downloadFile() {
      this.downloading = true;
      try {
        const url = window.URL.createObjectURL(this.blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "audio.mp3";
        link.click();
        this.downloading = false;
      } catch (err) {
        this.downloading = false;
      }
    },

    updateTextToSpeechBox() {
      if(this.textToSpeech){
        this.textBody = this.mediaFileText;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-checkbox {
  margin-left: 0;
}
</style>
